import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import GeneralView from '@/views/GeneralView.vue'

import store from '@/store'
import { ConnectionWSShared } from '@leapsight/styleguide'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/portal',
    name: 'login'
  },
  {
    path: '/live-tracking',
    name: 'live-tracking'
  },
  {
    path: '/fleet-management',
    name: 'GeneralView',
    component: GeneralView,
    meta: {
      requiresAuth: true
    },
    children: [
      { path: '', redirect: { name: 'EntitiesView' } },
      {
        path: 'entities',
        name: 'EntitiesView',
        component: GeneralView,
        children: [
          {
            path: '',
            name: 'EntitiesList',
            component: () =>
              import(
                /* webpackChunkName: "entities" */ '../views/entities/EntitiesList.vue'
              )
          },
          {
            path: ':id',
            name: 'EntityDetail',
            props: true,
            component: () =>
              import(
                /* webpackChunkName: "entities" */ '../views/entities/EntityDetail.vue'
              )
          }
        ]
      },
      // Dynamic url for each entity
      {
        path: 'persons',
        name: 'PersonsView',
        component: GeneralView,
        children: [
          {
            path: '',
            name: 'PersonsList',
            component: () =>
              import(
                /* webpackChunkName: "persons" */ '../views/persons/PersonsList.vue'
              )
          },
          {
            path: 'new-person',
            name: 'NewPerson',
            props: true,
            meta: { requiresAdmin: true },
            component: () =>
              import(
                /* webpackChunkName: "persons" */ '../views/persons/NewPerson.vue'
              )
          },
          // Dynamic url for each entity
          {
            path: ':id',
            name: 'PersonDetail',
            props: true,
            component: () =>
              import(
                /* webpackChunkName: "persons" */ '../views/persons/PersonDetail.vue'
              )
          }
        ]
      },
      {
        path: 'geofences',
        name: 'geofences',
        component: () =>
          import(/* webpackChunkName: "geofences" */ '../views/Geofences.vue'),
        children: [
          {
            path: '',
            name: 'GeofencesList',
            component: () =>
              import(
                /* webpackChunkName: "geofences" */ '../components/geofences/list/datatable/DataTable.vue'
              )
          },
          {
            path: 'create',
            name: 'geofences-createZone',
            props: true,
            component: () =>
              import(
                /* webpackChunkName: "geofences" */ '../components/geofences/create/CreateZone.vue'
              )
          },
          // Dynamic url for each entity
          {
            path: ':id',
            name: 'GeofenceDetail',
            props: true,
            meta: { requiresAdmin: true },
            component: () =>
              import(
                /* webpackChunkName: "geofences" */ '../components/geofences/edit/GeofenceDetail.vue'
              )
          }
        ]
      },
      {
        path: 'agents',
        name: 'Agents',
        component: GeneralView,
        children: [
          {
            path: '',
            name: 'AgentsList',
            component: () =>
              import(/* webpackChunkName: "agents" */ '../views/Agents.vue')
          },
          {
            path: 'create',
            name: 'agent-create',
            component: () =>
              import(
                /* webpackChunkName: "agents" */ '@/components/agents/create/CreateAgent.vue'
              )
          },
          {
            path: ':id',
            name: 'AgentDetail',
            props: true,
            component: () =>
              import(
                /* webpackChunkName: "agents" */ '@/components/agents/edit/AgentDetail.vue'
              )
          }
        ]
      },
      {
        path: 'tags',
        name: 'Tags',
        component: GeneralView,
        children: [
          {
            path: '',
            name: 'TagsList',
            component: () =>
              import(/* webpackChunkName: "geofences" */ '@/views/Tags.vue')
          },
          {
            path: 'create',
            name: 'tags-create',
            props: true,
            component: () =>
              import(
                /* webpackChunkName: "geofences" */ '@/components/tags/Create.vue'
              )
          },
          {
            path: ':id',
            name: 'TagDetail',
            props: true,
            component: () =>
              import(
                /* webpackChunkName: "geofences" */ '@/components/tags/TagDetail.vue'
              )
          }
        ]
      },
      {
        path: 'points-of-interest',
        name: 'PointsList',
        component: () =>
          import(
            /* webpackChunkName: "pointsofinterest" */ '../views/PointsOfInterest.vue'
          ),
        children: [
          {
            path: '',
            name: 'PointsOfInterestList',
            component: () =>
              import(
                /* webpackChunkName: "pointsofinterest" */ '../components/pointsOfInterest/list/DataTable.vue'
              )
          },
          {
            path: 'create',
            name: 'pointsofinterest-create',
            props: true,
            component: () =>
              import(
                /* webpackChunkName: "pointsofinterest" */ '../components/pointsOfInterest/create/CreatePointsOfInterest.vue'
              )
          },
          {
            path: ':id',
            name: 'PointDetail',
            props: true,
            meta: { requiresAdmin: true },
            component: () =>
              import(
                /* webpackChunkName: "geofences" */ '../components/pointsOfInterest/edit/PointDetail.vue'
              )
          }
        ]
      },
      {
        path: 'person-groups',
        name: 'PersonGroups',
        component: GeneralView,
        children: [
          {
            path: '',
            name: 'PersonGroupsList',
            component: () =>
              import(/* webpackChunkName: "geofences" */ '@/views/PersonGroups.vue')
          },
          {
            path: 'create',
            name: 'person-group-create',
            props: true,
            component: () =>
              import(
                /* webpackChunkName: "geofences" */ '@/components/personGroups/Create.vue'
              )
          },
          {
            path: ':id',
            name: 'PersonGroupDetail',
            props: true,
            // meta: { requiresAdmin: true },
            component: () =>
              import(
                /* webpackChunkName: "geofences" */ '@/components/personGroups/PersonGroupDetail.vue'
              )
          }
        ]
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // Antes de ingresar a cualquier ruta, se verifica si el usuario está logueado correctamente
    if (store.getters['auth/isLoggedIn']) {
      if (to.matched.some(record => record.meta.requiresAdmin)) {
        // Se verifica rol del usuario antes de ingresar a rutas que requieren ser admin
        if (store.getters.isAdmin || store.getters.isAdminSubFleet) {
          next()
        } else {
          // En caso de que no sea admin, se redirige a vista principal
          next({ name: 'GeneralView' })
        }
      } else next()
    } else window.location.assign(`${window.location.origin}/portal/login`)
  } else next()
})

window.addEventListener('beforeunload', event => {
  ConnectionWSShared.closeConnection()
})

export default router
